<template>
  <div class="form_item">
    <div>
      <Label :required="required" :label="label" :for_id="save_to" />
      <div class="upload-btn-wrapper" v-if="uploading">
        [{{ name }}] Upload en cours ...
      </div>
      <div
        class="upload-btn-wrapper"
        v-else-if="
          (typeof val === 'string' || val instanceof String) &&
          val.startsWith('http')
        "
      >
        <span class="delete-multiplefiles" @click="deleteLink()">
          <svg viewBox="0 0 448 512">
            <path
              d="M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128V432c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V128H80zm80 64V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z"
            />
          </svg>
        </span>
        <a :href="val">{{ decodeURI(val.split("/").slice(-1)[0]) }}</a>
      </div>
      <div class="upload-btn-wrapper" v-else>
        <button
          class="upload-btn"
          type="button"
          v-html="buttonUploadLabel"
          v-if="isButtonUpload"
        ></button>
        <input
          v-validate="rules"
          :id="save_to"
          type="file"
          :name="validationLabel || label"
          :key="save_to"
          :ref="save_to"
          v-on:change="handleFileUpload()"
          :required="!this.val && required"
          :autocomplete="autocomplete"
          :class="{ 'has-error': errors.has(label) }"
          :accept="accept"
        />
      </div>
      <span
        class="upload-btn-set"
        v-if="
          isButtonUpload &&
          $refs[save_to] &&
          $refs[save_to].files &&
          $refs[save_to].files[0]
        "
        >{{ $refs[save_to].files[0].name }}</span
      >
      <span
        v-else-if="typeof val === 'string' && val.startsWith('data:')"
        class="upload-btn-set"
      >
        1 fichier sélectionné
      </span>
    </div>
    <p v-if="info !== undefined" class="info" v-html="info"></p>
    <span class="warning" v-if="blurry && !disableBlurCheck && locale == 'fr'"
      >⚠️ {{ $t("blurry_document", locale) }}</span
    >
    <span class="error" v-show="errors.has(validationLabel || label)">{{
      errors.first(validationLabel || label)
    }}</span>
    <div v-if="uploading">
      <input
        type="checkbox"
        name="isUploading"
        v-model="isUploadingCheckbox"
        v-validate="'required'"
        style="display: none"
      />
      <span class="error" v-if="errors.has('isUploading')"
        >Veuillez patienter, un ou plusieurs fichiers sont en cours de
        téléchargement. Ne validez pas le formulaire avant la fin de
        l'opération</span
      >
    </div>
  </div>
</template>

<script>
import { validatorComponent } from "./validatorComponentMixin";
import init, { variance_of_laplacian } from "../rust_blur_lib/blur";
import i18n from "./i18n";
import axios from "axios";

export default {
  name: "Input",
  mixins: [validatorComponent, i18n.mixin],
  props: {
    save_to: String,
    type: String,
    isButtonUpload: Boolean,
    buttonUploadLabel: String,
    validationLabel: String,
    operationId: String,
    locale: {
      type: String,
      default: "fr",
    },
    disableBlurCheck: Boolean,
    sizeMax: {
      type: Number,
      default: 2560,
    },
    accept: {
      type: String,
      //required: true
    },
    required: Boolean,
    validationRules: [String, Object],
    autocomplete: String,
    inputmode: {
      type: String,
      default: "text",
    },
    pattern: String,
  },
  data: function () {
    return {
      blurry: false,
      isUploadingCheckbox: false,
      uploading: false,
      name: "",
    };
  },
  computed: {
    rules() {
      if (this.require) {
        return "required|size:" + this.sizeMax;
      }
      return "size:" + this.sizeMax;
    },
  },
  methods: {
    deleteLink() {
      this.val = undefined;
    },
    handleFileUpload() {
      this.blurry = false;
      const file = this.$refs[this.save_to].files[0];
      if (file !== "undefined") {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = async () => {
          this.val = reader.result;
          if (reader.result.indexOf("data:application/pdf") !== 0) {
            this.test(reader.result);
          }
          if (this.isDirectUpload) {
            try {
              this.uploading = true;
              this.name = file.name;
              const { data } = await axios.post(
                "https://api.lucien.ai/api/v2/submissions/upload",
                {
                  b64file: reader.result,
                  filename: file.name,
                  operationId: this.operationId,
                },
              );
              this.val = data.url;
              this.uploading = false;
            } catch (err) {
              this.uploading = false;
              console.log(err);
            }
          }
        };
      }
    },
    async test(fileReaderResult) {
      console.log("test blur");
      const canvas = document.createElement("canvas");
      const img = new Image();
      img.src = fileReaderResult;
      await new Promise(function (resolve) {
        img.onload = resolve;
      });
      const ctx = canvas.getContext("2d");
      const w = img.width,
        h = img.height;
      canvas.height = h;
      canvas.width = w;
      ctx.drawImage(img, 0, 0, w, h);
      await init();
      const imageData = ctx.getImageData(0, 0, w, h);
      const blurIndex = await variance_of_laplacian(imageData.data, w, h);
      console.log("test blur done blurIndex:", blurIndex);

      if (blurIndex < 130) {
        this.blurry = true;
      }
    },
  },
};
</script>
